import React from 'react'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { TokenizedCardDetails } from 'api/NPayments/Types/TokenizedCardDetails'
import { AuditLogIcon } from 'icons/AuditLogIcon'

interface TokenizedCardsDropdownMenuProps {
  canBrowseTokenizedCardDetails: boolean
  canEditTokenizedCardDetails: boolean
  dataItem: TokenizedCardDetails
  onEditCardholderNameModal(data: TokenizedCardDetails): void
  onEditStatusModal(data: TokenizedCardDetails): void
  onAuditModalOpen(data: TokenizedCardDetails): void
}

export const TokenizedCardsDropdownMenu: React.FC<TokenizedCardsDropdownMenuProps> = ({
  canBrowseTokenizedCardDetails,
  canEditTokenizedCardDetails,
  dataItem,
  onEditCardholderNameModal,
  onEditStatusModal,
  onAuditModalOpen,
}) => {
  return (
    <>
      <DropdownMenuItem
        disabled={!canEditTokenizedCardDetails}
        onSelect={() => onEditCardholderNameModal(dataItem)}
      >
        Edit Cardholder Name
      </DropdownMenuItem>
      <DropdownMenuItem
        disabled={!canEditTokenizedCardDetails}
        onSelect={() => onEditStatusModal(dataItem)}
      >
        Update Status
      </DropdownMenuItem>
      <DropdownMenuItem
        disabled={!canBrowseTokenizedCardDetails}
        onSelect={() => onAuditModalOpen(dataItem)}
      >
        <AuditLogIcon style={{ width: 12, height: 12, cursor: 'pointer' }} /> Audit Log
      </DropdownMenuItem>
    </>
  )
}
